
export const event_type_list = [
    { id: 'official', label: 'mostra di libro genealogico' },
    { id: 'local', label: 'mostra zonale/locale' }
]
export const event_category_list_old = [
    { id: 'nazionale', label: 'mostra nazionale' },
    { id: 'internazionale', label: 'mostra internazionale' },
    { id: 'interregionale', label: 'mostra interregionale' },
    { id: 'sperimentale', label: 'mostra sperimentale' },
    { id: 'regionale', label: 'mostra regionale' },
    { id: 'interprovinciale', label: 'mostra interprovinciale' },
    { id: 'provinciale', label: 'mostra provinciale' },
    { id: 'locale', label: 'mostra locale' },
]
export const event_category_list = [
    {id: 'N', label: 'Mostra Nazionale'},
    {id: 'E', label: 'Mostra Nazionale Jersey'},
    {id: 'D', label: 'Dairy Show'},
    {id: 'I', label: 'Mostra Interregionale'},
    {id: 'R', label: 'Mostra Regionale'},
    {id: 'J', label: 'Mostra Interprovinciale'},
    {id: 'P', label: 'Mostra Provinciale'},
    {id: 'L', label: 'Mostra Locale'},
    {id: 'Y', label: 'Junior Show'},
    {id: 'S', label: 'Speciale'},
    {id: 'X', label: 'Grand Prix'},
]

export const newevent = {
    is_public: false,
    is_archived: false,
    event_name: '',
    id_protocol: '',
    event_description: '',
    event_start: new Date(),
    event_end: new Date(),
    event_type: 'official',
    event_category: 'nazionale'
}